/*
 * @Author: Qiong
 * @Date: ****** 17:14
 * @LastEditTime: 2022-09-14 17:14
 * @LastEditors: Qiong
 * @Description: System Logs 日志
 * @Do not edit
 */
const initialState = {
    userInfo :{}
};
const userUnitInfo = (state = initialState ,action) => {
    switch (action.type){
        case "SAVE_UNIT" :{
            return action.userInfo;
        }
        default:
            return state;
    }
}
export default userUnitInfo;
